export const tipoAjuste = {
    Ingreso: 4,
    Egreso: 5
}

export const lstTipoAjuste = [
    {
        tipoAjusteId: tipoAjuste.Ingreso,
        nombre: "Ingreso"
    },
    {
        tipoAjusteId: tipoAjuste.Egreso,
        nombre: "Egreso"
    }
];